module.exports = __webpack_public_path__ + "static/media/mark-oval.e36c002a.svg";